var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-jitsi-meet',{ref:"jitsiRef",staticClass:"content",staticStyle:{"height":"100vh"},attrs:{"domain":"meet.silabu.com","options":_vm.jitsiOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }